import styled from 'styled-components';

import { Text } from '../../../../components';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const Hint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACE[8]};
`;

export const Modes = styled.div`
  display: flex;
  gap: ${SPACE[2]};
  padding: ${SPACE[2]};
  border-radius: 10px;
  background: ${COLORS.surfaceFaint};
`;

export const ModeButton = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: ${SPACE[8]} ${SPACE[12]};
  border: 0;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? COLORS.surfaceMuted : 'transparent')};
  color: ${({ $active }) => ($active ? COLORS.text : COLORS.textMuted)};
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background ${ANIM.INTERACT_MS}ms ease;
`;
